var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrcodepay-wrap"},[_c('div',{staticClass:"qrcode-wrap"},[_c('qriously',{staticClass:"qrcode",attrs:{"value":_vm.applyResult,"size":200}}),_c('div',{staticClass:"qr-guide-1 qr-guide-1-wxpay"})],1),_c('div',{staticClass:"qr-guide-2 qr-guide-2-wxpay"})])
}
var staticRenderFns = []

export { render, staticRenderFns }